import './CalendlyWidget.css';
import { useEffect } from 'react';

export const CalendlyWidget = (): JSX.Element => {
	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://assets.calendly.com/assets/external/widget.js';
		script.async = true;
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, []);

	return (
		<>
			<div
				className="calendly-inline-widget mx-auto h-[450px] min-w-full md:h-172"
				data-url="https://calendly.com/worky-se?hide_landing_page_details=1&hide_gdpr_banner=1&primary_color=78e989"
			></div>
		</>
	);
};
